import { createFileRoute } from "@tanstack/react-router";
import { ProductSimulationPage } from "../../components/system/ProductSimulationPage";
import { requireSuperAdmin } from "../../lib/auth/route-protection";

export const Route = createFileRoute("/system/product-simulation")({
  beforeLoad: requireSuperAdmin(),
  component: ProductSimulationPage,
});
